import React from 'react';
import { Modal, Button } from 'rsuite';
import './eaeuManagerModal.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function EAEUManagerModal({ open, onClose, onSkip, contractNumber }) {
  const navigate = useNavigate();
  const { t } = useTranslation('basic');

  const handleChatClick = () => {
    // Navigate to enter_chat with contract_number parameter
    navigate(`/enter_chat?contract_number=${contractNumber}`);
    onClose();
  };

  const handleSkipClick = () => {
    onSkip();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} size="md" className="eaeuManagerModal">
      <Modal.Header>
        <Modal.Title>{t("additional_information_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="paragraph-14R">
          {t("eaeu_manager_modal_text")}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleChatClick} appearance="primary" color="green" style={{ marginRight: '10px' }}>
          {t("chat_with_manager")}
        </Button>
        <Button onClick={handleSkipClick} appearance="default">
          {t("skip")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


